export default __webpack_public_path__ + "static/media/Pyra_pink.bcbe8c2f.png";